import React, { useState } from 'react';

import { InputWithImage } from './InputWithHide.style';
import { Input } from 'reactstrap';

const InputWithHide = props => {
  const [isInputHidden, setIsInputHidden] = useState(true);

  return (
    <InputWithImage>
      <Input
        type={isInputHidden ? 'password' : 'text'}
        innerRef={props.innerRef}
        name={props.name}
        disabled={props.disabled}
        id={props.name}
      />
      <div
        onClick={() => setIsInputHidden(prev => !prev)}
        className="dds__icons dds__eye-view-on"
      ></div>
    </InputWithImage>
  );
};

export default InputWithHide;
